import React from "react";
import { compose } from "recompose";
import EnhanceMiniCartContent from "theme/modules/Cart/MiniCart/MiniCartContent/EnhanceMiniCartContent";
import CartQuery from "theme/pages/Cart/CartQuery.gql";
import { withHideOnErrorBoundary } from "theme/components/helpers/ErrorBoundary";
import MiniCartContentLoading from "./MiniCartContentLoading";
import MiniCartTitle from "./MiniCartTitle";
import MiniCartItemList from "theme/modules/Cart/MiniCart/MiniCartContent/MiniCartItemList";
import MiniCartTotal from "./MiniCartTotal";
import MiniCartActions from "./MiniCartActions";
import MiniCartContentError from "./MiniCartContentError";
import MinicartMinOrderAmount from "./MinicartMinOrderAmount";

const MiniCartContent = ({
  cartData,
  customerBillingCountry,
  toggleMiniCart,
}) => {
  const loading = cartData?.loading;
  const error = cartData?.error;
  const cart = cartData?.cart;
  if (loading) {
    return <MiniCartContentLoading />;
  }

  if (error) {
    return <MiniCartContentError toggleMiniCart={toggleMiniCart} />;
  }

  // Safe-guards when cart is undefined/null
  if (!cart || !cart.items) {
    return (
      <div className="mini-cart-content">
        <div className="container">
          <div className="mini-cart-content__inner">
            <MiniCartTitle cart={cart} toggleMiniCart={toggleMiniCart} />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="mini-cart-content">
      <div className="container">
        <div className="mini-cart-content__inner">
          <MiniCartTitle cart={cart} toggleMiniCart={toggleMiniCart} />
          <div className="mini-cart-content__main">
            <MiniCartItemList cart={cart} />
          </div>
          <div className="mini-cart-content__bottom">
            <div className="mini-cart-content__total">
              {cart.items.length > 0 && (
                <MiniCartTotal key="total" cart={cart} />
              )}
            </div>
            {cart.items.length > 0 && (
              <MiniCartActions key="actions" cart={cart} />
            )}
          </div>
          <div className="mini-cart-content__min-order-amount">
            <MinicartMinOrderAmount cart={cart} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default compose(
  withHideOnErrorBoundary,
  EnhanceMiniCartContent({ CartQuery })
)(MiniCartContent);
